// Trims exactly what Python's str.strip() strips (the backend normalizes short codes
// with it). Deliberately NOT String.prototype.trim()/\s: JS trim() also strips U+FEFF,
// which Python does not, so a legacy code with a BOM would be silently rewritten.
const PY_WHITESPACE =
  '\t\n\v\f\r\x1c-\x1f \x85\xa0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000';
const PY_STRIP_RE = new RegExp(`^[${PY_WHITESPACE}]+|[${PY_WHITESPACE}]+$`, 'g');

export function trimShortCode(value: string): string {
  return value.replace(PY_STRIP_RE, '');
}
